
      (() => {
        const maxDuration = 3000;
        const intervalDelay = 200;
        const startTime = Date.now();
        let wrapperRemoved = false;
        const intervalId = setInterval(() => {
          const wrapper = document.querySelector('#PBarNextFrameWrapper');
          if (wrapper && !wrapperRemoved) {
            wrapper.remove();
            wrapperRemoved = true;
          }
          if (wrapperRemoved) {
            clearInterval(intervalId);
            return;
          }
          if (Date.now() - startTime >= maxDuration) {
            clearInterval(intervalId);
          }
        }, intervalDelay);
      })();



    
// const observer = new MutationObserver(() => {
//   const deselectBtn = document.querySelector('.pplr_deselect');
//   const selectBox = document.querySelector('select.cstmfy_c_required');
//   const colorSpans = document.querySelectorAll('.pplrcolorimage.img_thumb_small_circle span');


//   if (deselectBtn && selectBox && colorSpans.length) {
//     observer.disconnect();

//     function triggerDeselectWhenReady() {
//       if (document.body.contains(deselectBtn) && deselectBtn.offsetParent !== null) {
//         deselectBtn.click();
//         const noneOption = selectBox.querySelector('option[value="None"]');
//         if (noneOption) {
//           selectBox.value = 'None';
//           selectBox.dispatchEvent(new Event('change', { bubbles: true }));
//         }
//       } else {
//         requestAnimationFrame(triggerDeselectWhenReady);
//       }
//     }

//     triggerDeselectWhenReady();

//     deselectBtn.addEventListener('click', () => {
//       const noneOption = selectBox.querySelector('option[value="None"]');
//       if (noneOption) {
//         selectBox.value = 'None';
//         selectBox.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     });

//     colorSpans.forEach(span => {
//       span.addEventListener('click', () => {
//         const motifOption = selectBox.querySelector('option[value="Select Motif"]');
//         if (motifOption) {
//           selectBox.value = 'Select Motif';
//           selectBox.dispatchEvent(new Event('change', { bubbles: true }));
//         }
//       });
//     });
//   }
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });

// working

// const observer = new MutationObserver(() => {
//   const deselectLink = document.querySelector('a[name="properties[Motifs]"]');
//   const motifSelect = document.querySelector('select.cstmfy_c_required[name="properties[Choose Motif Option]"]');
//   const motifSpans = document.querySelectorAll('span[name="properties[Motifs]"]');

//   if (deselectLink && motifSelect && motifSpans.length) {
//     observer.disconnect();

   
//     function setNoneOption() {
//       const noneOption = motifSelect.querySelector('option[value="None"]');
//       if (noneOption) {
//         motifSelect.value = 'None';
//         motifSelect.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     }

    
//     function setSelectMotifOption() {
//       const selectOption = motifSelect.querySelector('option[value="Select Motif"]');
//       if (selectOption) {
//         motifSelect.value = 'Select Motif';
//         motifSelect.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     }

    
//     function autoClickRemove() {
//       if (document.body.contains(deselectLink) && deselectLink.offsetParent !== null) {
//         deselectLink.click();
//         setNoneOption();
//       } else {
//         requestAnimationFrame(autoClickRemove);
//       }
//     }

//     autoClickRemove();


//     deselectLink.addEventListener('click', () => {
//       setNoneOption();
//     });

    
//     motifSpans.forEach(span => {
//       span.addEventListener('click', () => {
//         setSelectMotifOption();
//       });
//     });
//   }
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });


const observer = new MutationObserver(() => {
  const deselectLink = document.querySelector('a[name="properties[Motifs]"]');
  const motifSelect = document.querySelector('select.cstmfy_c_required[name="properties[Choose Motif Option]"]');
  const motifSpans = document.querySelectorAll('span[name="properties[Motifs]"]');
  const dropdownEl = document.querySelector('.pplr-selecter-selected.dropdowncolor:not(.color_p_main)'); 

  if (deselectLink && motifSelect && motifSpans.length && dropdownEl) {
    observer.disconnect();


    function setNoneOption() {
      const noneOption = motifSelect.querySelector('option[value="None"]');
      if (noneOption) {
        motifSelect.value = 'None';
        motifSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function setSelectMotifOption() {
      const selectOption = motifSelect.querySelector('option[value="Select Motif"]');
      if (selectOption) {
        motifSelect.value = 'Select Motif';
        motifSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }


    function autoClickRemove() {
      if (deselectLink.offsetParent !== null) {
        deselectLink.click();
        setNoneOption();
       
      } else {
        requestAnimationFrame(autoClickRemove);
      }
    }

   
    function autoClickDropdown() {
      if (dropdownEl && dropdownEl.offsetParent !== null) {
        dropdownEl.click();
      } else {
        requestAnimationFrame(autoClickDropdown);
      }
    }


    setTimeout(() => {
      autoClickRemove();
      autoClickDropdown();
    }, 1000);


    deselectLink.addEventListener('click', setNoneOption);

    motifSpans.forEach(span => {
      span.addEventListener('click', setSelectMotifOption);
    });
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});



document.addEventListener("click", function (e) {
  const quickAddBtn = e.target.closest(".quick-add__button");
  if (!quickAddBtn) return; 
  setTimeout(() => {
    const addToCartBtns = document.querySelectorAll(".pplr_add_to_cart");
    addToCartBtns.forEach((btn) => {
      if (btn.closest("dialog")) {
        btn.classList.remove("pplr_add_to_cart");
      }
    });
  }, 300); 
});
